document.addEventListener('DOMContentLoaded', function () {
  const canvas = document.getElementById('ripple-canvas');
  const ctx = canvas.getContext('2d');
  const title = document.getElementById('banner-title');
  let ripples = [];

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = 800;
  }

  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  canvas.addEventListener('click', (e) => {
    createRipple(e.clientX, e.clientY);
  });

  title.addEventListener('click', (e) => {
    createRipple(e.clientX, e.clientY);
  });

  function createRipple(x, y) {
    ripples.push({ x, y, radius: 0, alpha: 1 });
  }

  function drawRipples() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ripples.forEach((ripple, index) => {
      ripple.radius += 4;
      ripple.alpha -= 0.01;
      if (ripple.alpha <= 0) ripples.splice(index, 1);
      else {
        ctx.beginPath();
        ctx.arc(ripple.x, ripple.y, ripple.radius, 0, 2 * Math.PI);
        ctx.strokeStyle = `rgba(255,255,255,${ripple.alpha})`;
        ctx.lineWidth = 2;
        ctx.stroke();
      }
    });
    requestAnimationFrame(drawRipples);
  }

  drawRipples();
});
